import { Model } from '@vuex-orm/core'
import { Request } from '@vuex-orm/plugin-axios'
import { getCode } from '@/lang';
import AppState from '@/utils/app.state'

/* The fallback adult age (if not found) */
const DEFAULT_ADULT_AGE_FROM = 50

export default class AgeGroup extends Model {
  declare id: string
  declare name?: string
  declare maxAge: number
  declare minAge: number
  declare type: number

  static entity = 'ageGroup'

  static fields() {
    return {
      id: this.uid(),
      name: this.string(null),
      maxAge: this.number(0),
      minAge: this.number(0),
      type: this.number(0)
    }
  }

  static getAdultAge() {
    const adultAgeGroup = AgeGroup.query().where('type', 1).first()
    return adultAgeGroup ? adultAgeGroup.minAge : DEFAULT_ADULT_AGE_FROM
  }

  static apiConfig = {
    actions: {
      fetch(this: Request) {
        return this.post(
          '/content/v2/policies/getagegroupsbypropertyids',
          {
            propertyIDs: [AppState.currentProperty],
            languageCodes: [getCode()]
          }
        )
      }
    }
  }
}
